<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="角色类型">
                <a-select placeholder="请选择" v-model="queryParam.role" style="width: 100%" allow-clear>
                  <a-select-option value="用户">用户</a-select-option>
                  <a-select-option value="代理商">代理商</a-select-option>
                  <a-select-option value="场地">场地</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="提现开关">
                <a-select placeholder="请选择" v-model="queryParam.withdrawalSwitch" style="width: 100%" allow-clear>
                  <a-select-option :value="0">开</a-select-option>
                  <a-select-option :value="1">关</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="自动转账">
                <a-select placeholder="请选择" v-model="queryParam.automaticWithdrawal" style="width: 100%" allow-clear>
                  <a-select-option :value="0">关闭</a-select-option>
                  <a-select-option :value="1">打开</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="人工二次审核">
                <a-select placeholder="请选择" v-model="queryParam.openAudit" style="width: 100%" allow-clear>
                  <a-select-option :value="0">关闭</a-select-option>
                  <a-select-option :value="1">打开</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="advanced">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="createTimeValue"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeCreateTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 18" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd" v-hasPermi="['sys:fund:withdrawal:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['sys:fund:withdrawal:export']">
          <a-icon type="download" />导出
        </a-button>
      </div>

      <a-spin :spinning="loading">
        <div class="config-card-list" v-if="!loading || displayList.length > 0">
          <div class="config-card" v-for="record in displayList" :key="record.roleType">
            <div class="card-header">
              <div class="card-header-left">
                <a-tag class="role-tag" color="blue" size="large">{{ getRoleText(record.role) }}</a-tag>
              </div>
              <div class="card-header-right">
                <a-dropdown :trigger="['click']" v-hasPermi="['sys:fund:withdrawal:edit']">
                  <a class="more-action">
                    <a-icon type="more" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item v-hasPermi="['sys:fund:withdrawal:edit']">
                      <a @click="handleEdit(record)" :disabled="!record.id"> <a-icon type="edit" />编辑 </a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </div>
            </div>
            <div class="card-body">
              <a-descriptions :column="1" size="small" bordered>
                <a-descriptions-item label="提现开关">
                  <a-tag
                    v-if="record.withdrawalSwitch !== undefined && record.withdrawalSwitch !== null"
                    :color="record.withdrawalSwitch === 0 ? 'green' : 'red'"
                  >
                    {{ record.withdrawalSwitch === 0 ? '开' : '关' }}
                  </a-tag>
                  <span v-else>--</span>
                </a-descriptions-item>
                <a-descriptions-item label="自动转账">
                  <a-tag
                    v-if="record.automaticWithdrawal !== undefined && record.automaticWithdrawal !== null"
                    :color="record.automaticWithdrawal === 1 ? 'green' : 'orange'"
                  >
                    {{ record.automaticWithdrawal === 1 ? '打开' : '关闭' }}
                  </a-tag>
                  <span v-else>--</span>
                </a-descriptions-item>
                <a-descriptions-item label="人工二次审核">
                  <a-tag
                    v-if="record.openAudit !== undefined && record.openAudit !== null"
                    :color="record.openAudit === 1 ? 'green' : 'orange'"
                  >
                    {{ record.openAudit === 1 ? '打开' : '关闭' }}
                  </a-tag>
                  <span v-else>--</span>
                </a-descriptions-item>
                <a-descriptions-item label="起步提现金额">
                  <span class="money-text" v-if="record.leastMoney !== undefined && record.leastMoney !== null"
                    >¥{{ record.leastMoney }}</span
                  >
                  <span v-else>--</span>
                </a-descriptions-item>
                <a-descriptions-item label="最大提现金额(日)">
                  <span class="money-text" v-if="record.dayMaxMoney !== undefined && record.dayMaxMoney !== null"
                    >¥{{ record.dayMaxMoney }}</span
                  >
                  <span v-else>--</span>
                </a-descriptions-item>
                <a-descriptions-item label="手续费">
                  <span class="money-text" v-if="record.fee !== undefined && record.fee !== null"
                    >¥{{ record.fee }}</span
                  >
                  <span v-else>--</span>
                </a-descriptions-item>
                <a-descriptions-item label="窗口期">
                  <span
                    v-if="
                      record.windowsTimeStart !== undefined &&
                      record.windowsTimeEnd !== undefined &&
                      record.windowsTimeStart !== null &&
                      record.windowsTimeEnd !== null
                    "
                  >
                    {{ record.windowsTimeStart }}:00 - {{ record.windowsTimeEnd }}:00
                  </span>
                  <span v-else>--</span>
                </a-descriptions-item>
                <a-descriptions-item label="创建时间">
                  <span v-if="record.createTime">{{ record.createTime }}</span>
                  <span v-else>--</span>
                </a-descriptions-item>
                <a-descriptions-item label="备注" :span="1">
                  <a-tooltip v-if="record.remark" :title="record.remark">
                    <span class="text-ellipsis">{{ record.remark }}</span>
                  </a-tooltip>
                  <span v-else>--</span>
                </a-descriptions-item>
              </a-descriptions>
            </div>
          </div>
        </div>
      </a-spin>
      <form-drawer ref="formDrawer" @success="handleAddSuccess" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchWithdrawalConfigList } from '@/api/pressure/fund'
import moment from 'moment'
import FormDrawer from './modules/FormDrawer'

export default {
  name: 'WithdrawalConfiguration',
  components: {
    FormDrawer,
  },
  data() {
    return {
      list: [],
      displayList: [],
      queryParam: {
        role: undefined,
        withdrawalSwitch: undefined,
        automaticWithdrawal: undefined,
        openAudit: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        sortField: undefined,
        sortOrder: undefined,
      },
      total: 0,
      createTimeValue: [],
      advanced: false,
      loading: false,
      tableSize: 'default',
    }
  },
  methods: {
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        role: undefined,
        withdrawalSwitch: undefined,
        automaticWithdrawal: undefined,
        openAudit: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        sortField: undefined,
        sortOrder: undefined,
      }
      this.createTimeValue = []
      this.handleQuery()
    },
    getList() {
      this.loading = true
      fetchWithdrawalConfigList(this.queryParam)
        .then((res) => {
          this.list = res.data || []
          this.total = this.list.length
          this.buildDisplayList()
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    buildDisplayList() {
      // 默认展示三个角色类型的卡片：USER、AGENT、SITE
      const roleTypes = ['USER', 'AGENT', 'SITE']
      const defaultCard = {
        withdrawalSwitch: null,
        automaticWithdrawal: null,
        openAudit: null,
        leastMoney: null,
        dayMaxMoney: null,
        fee: null,
        windowsTimeStart: null,
        windowsTimeEnd: null,
        createTime: null,
        remark: null,
      }
      this.displayList = roleTypes.map((roleType) => {
        // 查找列表中是否有对应角色类型的数据
        const found = this.list.find((item) => item.role === roleType)
        if (found) {
          // 如果有数据，使用真实数据
          return {
            ...found,
            roleType: roleType,
          }
        } else {
          // 如果没有数据，创建空卡片
          return {
            ...defaultCard,
            role: roleType,
            roleType: roleType,
          }
        }
      })
    },
    onChangeCreateTime(e) {
      if (e && e.length === 2) {
        this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
        this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
    },
    handleAdd() {
      this.$refs.formDrawer.init()
    },
    handleEdit(record) {
      if (!record.id) {
        // 如果没有 id，说明是空卡片，需要新建
        // 创建一个包含 roleType 的记录用于新增
        this.$refs.formDrawer.init({ role: record.roleType })
      } else {
        // 有 id，正常编辑
        this.$refs.formDrawer.init(record)
      }
    },
    handleAddSuccess() {
      this.getList()
    },
    getRoleText(role) {
      // 角色类型映射：USER用户，AGENT代理商，SITE场地
      const roleMap = {
        USER: '用户',
        AGENT: '代理商',
        SITE: '场地',
      }
      return roleMap[role] || '--'
    },
    handleExport() {
      const that = this
      this.$confirm({
        title: '导出数据',
        content: '确认导出当前筛选条件下的所有数据吗？',
        onOk() {
          that.download(
            'sys/fund/withdrawal/config/export',
            {
              ...that.queryParam,
            },
            `资金提现配置列表_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
  created() {
    this.getList()
  },
}
</script>

<style lang="less" scoped>
.text-ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.config-card-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 24px;
  padding: 0;
}
.config-card {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
    border-color: #1890ff;
  }
  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
    background: #fafafa;
    .card-header-left {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;
      .role-tag {
        font-size: 14px;
        font-weight: 500;
        padding: 4px 12px;
        border-radius: 4px;
      }
    }
    .card-header-right {
      .more-action {
        font-size: 18px;
        color: rgba(0, 0, 0, 0.45);
        cursor: pointer;
        padding: 4px 8px;
        border-radius: 4px;
        transition: all 0.3s;
        &:hover {
          background: #e6f7ff;
          color: #1890ff;
        }
      }
    }
  }
  .card-body {
    padding: 20px;
    /deep/ .ant-descriptions {
      .ant-descriptions-item-label {
        width: 140px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.65);
        background: #fafafa;
      }
      .ant-descriptions-item-content {
        color: rgba(0, 0, 0, 0.85);
      }
      .ant-descriptions-row {
        border-bottom: 1px solid #f0f0f0;
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .money-text {
      color: #ff4d4f;
      font-weight: 500;
      font-size: 14px;
    }
  }
}
@media (max-width: 768px) {
  .config-card-list {
    grid-template-columns: 1fr;
  }
}
</style>
